export default function Insurance() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="insurance" className="py-0">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-screen">
        <div className="relative bg-amber-50 flex items-center justify-center p-12">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/878260c291a99f10828784003f60905c.jpg"
              alt="Insurance Coverage"
              className="w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-br from-amber-900/40 to-amber-800/30"></div>
          </div>
          <div className="relative z-10 text-left max-w-md">
            <span className="text-sm text-amber-200 uppercase tracking-wider mb-4 block">
              ACCEPTED COVERAGE
            </span>
            <h2 className="text-white leading-tight">
              <span className="block text-4xl font-semibold mb-2">We Work</span>
              <span className="block text-5xl font-bold mb-2">With Your</span>
              <span className="block text-7xl font-black">INSURANCE</span>
            </h2>
          </div>
        </div>

        <div className="bg-white flex items-center justify-center p-12 lg:p-16">
          <div className="max-w-lg text-center">
            <h2 className="text-5xl font-bold text-gray-900 mb-8 leading-tight">
              Medicaid &amp; Medicare<br />Accepted Here
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-10">
              We work directly with Medicaid, Medicare, and most major insurance providers to ensure your transportation needs are covered. Our team handles all the paperwork and verification, making the process seamless for you. Simply provide your insurance information, and we'll take care of the rest.
            </p>
            <button
              onClick={() => scrollToSection('contact')}
              className="px-8 py-4 bg-teal-600 text-white rounded-full text-base font-semibold hover:bg-teal-700 transition-all inline-flex items-center whitespace-nowrap cursor-pointer"
            >
              Verify Coverage
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
